<div class="form-header-element">
  <span class="header paragraph-medium-regular">{{ formElement.title }}</span>
  <span class="header-value paragraph-medium-bold">{{ formElement.value }}</span>
</div>
